import {SpanIcon} from '@mazraeapp/react_icon_kit';
import {FormItemValueProps} from './type';

const FormItemValue = ({
  isDisable,
  value,
  removeValue,
  valueType,
}: FormItemValueProps) => {
  return (
    <div
      className={`mt-2 flex items-center gap-1 px-2 py-1 rounded-2xl text-sm !border ${
        !isDisable
          ? 'text-farm-shop-500 bg-farm-shop-50 !border-farm-shop-500'
          : 'text-gray-400 bg-gray-50 !border-gray-400'
      }`}
    >
      {isDisable ? (
        <>
          <span>{value.title}</span>
          <SpanIcon className="icon-nameClose-remove text-base" />
        </>
      ) : (
        <>
          <span>{value.title}</span>
          <SpanIcon
            className="icon-nameClose-remove text-base"
            onClick={() => {
              if (valueType === 'array') {
                removeValue(value.id as number);
                return;
              }
              removeValue();
            }}
          />
        </>
      )}
    </div>
  );
};

export default FormItemValue;
